export const NO_PAGE_CACHE = 'no-page-cache';
export const COMPONENT_CACHING = 'component-caching';
export const SHOW_WEBFORM = 'show-webform';
export const SHOW_CONFIRMATION = 'show-confirmation';
export const OPEN_HELP_CENTRE_WEBFORM = 'help-centre';
